import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Components/Header/Header";
import Body from "./Components/body/Body";
import Footer from "./Components/Footer/Footer"
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer, toast } from 'react-toastify';
import Loader from "./Components/utils/Loader";
import { dispatchLogin, fetchUser, dispatchGetUser } from "./redux/actions/authAction";


const App = () => {

  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)
  const token = useSelector((state) => state.token)
  const [loading, setLoading] = useState(false)
  
  useEffect(() => {
    const firstLogin = JSON.parse(localStorage.getItem('login'))
    if (!firstLogin) {
      setLoading(true)
      let login = {isLogged: false, email: '', name: '', password: ''}
      localStorage.setItem('login', JSON.stringify(login));
      setLoading(false)
    }
  }, [])

  // useEffect(() => {
  //   if (token) {
  //     setLoading(true)
  //     const getUser = () => {
  //       try {
  //         dispatch(dispatchLogin())
  //         return fetchUser(token).then((res) => {
  //           dispatch(dispatchGetUser(res))
  //         })
  //       }
  //       catch (err) {
  //         setLoading(false)
  //         toast.error('Error', { theme: "colored" })
  //       }

  //     }
  //     getUser()
  //     setLoading(false)
  //   }
  // }, [token, dispatch])




  return (
    <Router>
      <div className="App">
        <ToastContainer position="bottom-left" autoClose={2000} enableMultiContainer containerId={'DisplayInfo'} limit={6} 
        hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover/>

        <ToastContainer position="bottom-right" autoClose={false} enableMultiContainer containerId={'CoinsAlert'} limit={false} 
        hideProgressBar={true} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover/>

        <Header/>
        {
          loading ? <><Loader/></> : <> <Body/> </>
        }
        <Footer/>
      </div>
    </Router>
  );
};

export default App;
